{
  "uigOrgUser": {
    "header": "Alle Benutzer ({{count}})",
    "disabled": "(disabled)",
    "displayUid": "ID",
    "uid": "Email",
    "active": "Status",
    "name": "Name",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "Email",
    "orgUnit": "Unit",
    "unit": "Unit",
    "roles": "Roles",
    "title": "Title",
    "hint": "Alle Benutzer",
    "unitApprover": "Unit approver",
    "assignApprover": "Add the user to approvers for the unit",
    "actions": "",
    "sortBy": "Sortieren",
    "sort": {
      "byName": "Sortieren nach Name",
      "byUnit": "Sortieren nach Unit"
    },
    "details": {
      "title": "Benutzerdetails",
      "subtitle": "Benutzer: {{ item.name }}"
    },
    "edit": {
      "title": "Benutzer bearbeiten",
      "subtitle": "Benutzer: {{ item.name }}"
    },
    "create": {
      "title": "Benutzer erstellen",
      "subtitle": ""
    },
    "links": {
      "password": "Passwort ändern",
      "approvers": "Approvers",
      "userGroup": "User groups",
      "permission": "Purchase limits"
    },
    "messages": {
      "deactivateTitle": "Diesen Benutzer deaktivieren?",
      "deactivate": "Deaktivierte Benutzer können sich nicht mehr beim Shop anmelden und keine Bestellungen mehr durchführen.",
      "deactivateBody": "Deaktivierte Benutzer können sich nicht mehr beim Shop anmelden und keine Bestellungen mehr durchführen.",
      "confirmEnabled": "User {{item.firstName}} {{item.lastName}} enabled successfully",
      "confirmDisabled": "User {{item.firstName}} {{item.lastName}} disabled successfully",
      "update": "Benutzer {{item.firstName}} {{item.lastName}} wurde erfolgreich geändert.",
      "create": "Benutzer {{item.firstName}} {{item.lastName}} erfolgreich registriert.",
      "updatePassword": "Das Passwort wurde für Benutzer {{item.firstName}} {{item.lastName}} erfolgreich geändert.",
      "deleteUser": {
        "title": "Diesen Benutzer löschen?",
        "content": "Sind Sie sicher, dass dieser Benutzer gelöscht werden soll?",
        "confirm": "LÖSCHEN",
        "deleteConfirmation": "User successfully deleted"
      }
    },
    "info": {
      "disabledEdit": "Bearbeitungsmodus ist nur möglich, wenn Sie den Benutzer aktivieren.",
      "disabledEnable": "Unit must be enabled before this user may be enabled."
    },
    "approver": {
      "link": "Approvers",
      "header": "Approvers in {{code}}",
      "assign": "Assign Approvers",
      "assignHeader": "Assign Approvers in {{code}}",
      "back": "Back",
      "new": "New approver",
      "instructions": {
        "check": "To assign an approver to this user, select the user's check box.",
        "uncheck": "To remove an approver, clear the user's check box.",
        "changes": "Changes are saved automatically."
      }
    },
    "userGroup": {
      "link": "User groups",
      "header": "User groups in {{code}}",
      "assign": "Assign user groups",
      "assignHeader": "Assign user groups in {{code}}",
      "back": "Back",
      "instructions": {
        "check": "To assign an user group to this user, select the user's check box.",
        "uncheck": "To remove aa user group, clear the user's check box.",
        "changes": "Changes are saved automatically."
      }
    },
    "permission": {
      "link": "Purchase limits",
      "header": "Purchase limits in {{code}}",
      "assign": "Assign purchase limits",
      "assignHeader": "Assign purchase limits in {{code}}",
      "back": "Back",
      "instructions": {
        "check": "To assign a purchase limits to this user, select its check box.",
        "uncheck": "To unassign a purchase limits, clear its check box.",
        "changes": "Changes are saved automatically."
      },
      "per": {
        "undefined": "",
        "MONTH": "per Month",
        "YEAR": "per Year",
        "WEEK": "per Week",
        "QUARTER": "per Quarter"
      }
    },
    "password": {
      "title": "Passwort ändern",
      "subtitle": "Benutzer: {{ item.email }}",
      "newPassword": "Neues Passwort",
      "confirmPassword": "Neues Passwort wiederholen"
    },
    "breadcrumbs": {
      "list": "Alle Benutzer",
      "details": "{{name}}",
      "userGroups": "User groups",
      "approvers": "Approvers",
      "permissions": "Purchase limits"
    }
  }
}
